import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgMoneyIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 4.25h19.5v13.5H2.25z"
    />
    <circle cx={9} cy={9} r={2} stroke="currentColor" strokeWidth={1.5} />
    <circle cx={15} cy={11} r={2} stroke="currentColor" strokeWidth={1.5} />
    <path
      d="M7 7v6M13 9v6M9 11l2 2M7 21h10"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25 5c0 .69-.56 1.25-1.25 1.25h-.25v-1.5h1.5V5ZM21 6.25c-.69 0-1.25-.56-1.25-1.25v-.25h1.5v1.5H21ZM19.75 17c0-.69.56-1.25 1.25-1.25h.25v1.5h-1.5V17ZM3 15.75c.69 0 1.25.56 1.25 1.25v.25h-1.5v-1.5H3Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

const ForwardRef = forwardRef(SvgMoneyIcon);
const Memo = memo(ForwardRef);
export default Memo;
